function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { Path, Svg } from '@react-pdf/renderer';
import React from 'react';
export function PrintableElevatorIcon({
  color,
  ...props
}) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M15.819 10.956l-6.896-6.896-6.893 6.896-1.062-1.060 7.955-7.956 7.956 7.956zM15.076 22.061l-7.956-7.956 1.060-1.061 6.896 6.895 6.893-6.896 1.062 1.061z",
    fill: color
  }));
}